module.exports = __webpack_public_path__ + "media/customizations/regencyattracylakes/back-21d1f353ac8b96cb85aef7c4751a206c.jpg";